const ORGANISATION_EXCEPTION_LIST = ["gmail", "hotmail"];

export const isOrganisationExcluded = (organisation = ""): boolean => {
  return ORGANISATION_EXCEPTION_LIST.map((value) =>
    value.toLowerCase()
  ).includes(organisation?.toLowerCase());
};
